import Common from '../../Common';

const TriggerWord = class extends Common {
	async browse(profileId: id) {
		return this.get(`/profile/${profileId}/trigger_word`)
	}

	async create(profileId: id, body: {word: string}) {
		return this.post(`/profile/${profileId}/trigger_word`, body)
	}

	async delete(profileId: id, wordId: id) {
		return this.doDelete(`/profile/${profileId}/trigger_word/${wordId}`)
	}
}

export default TriggerWord;
